export default "__VITE_ASSET__DBNDjhGy__"